module.exports = __webpack_public_path__ + "static/media/vittorio_migliorini.490e3035.jpg";